var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMailOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 76,
    viewBox: "0 0 75 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M62.5 13H12.5C9.0625 13 6.28125 15.8125 6.28125 19.25L6.25 56.75C6.25 60.1875 9.0625 63 12.5 63H62.5C65.9375 63 68.75 60.1875 68.75 56.75V19.25C68.75 15.8125 65.9375 13 62.5 13ZM59.375 56.75H15.625C13.9062 56.75 12.5 55.3438 12.5 53.625V25.5L34.1875 39.0625C36.2187 40.3438 38.7812 40.3438 40.8125 39.0625L62.5 25.5V53.625C62.5 55.3438 61.0938 56.75 59.375 56.75ZM37.5 34.875L12.5 19.25H62.5L37.5 34.875Z",
    fill: "#316582"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailOutline);
export default __webpack_public_path__ + "static/media/mail-outline.3a809aefeebb3ebd89825f99f5c0914f.svg";
export { ForwardRef as ReactComponent };